// /ide — a read-only IDE workspace on the app's repo for the instance's
// admins, reachable without the internal claim.
//
// Same panel the Dev Console shows under its IDE view. An org admin/owner
// browses files, history and diffs in Eclipse Theia; the workspace is
// read-only on disk and carries no git credential (api/devIde.js refuses
// `edit` without the internal claim). Internal accounts land in edit mode
// here too, same as on /dev.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import IdePanel from '../components/ide/IdePanel';
import { useInternalClaim } from './DevConsole';
import { useTenant, isPrivileged } from '../data/entities';

export default function Ide() {
  const internal = useInternalClaim();
  const t = useTenant();
  const navigate = useNavigate();
  const admin = internal || isPrivileged(t.role);
  if (!admin) {
    return (
      <div className="cs-page">
        <div className="cs-empty">The IDE is for organization admins and owners{t.loaded ? '' : ' — loading your seat…'}.</div>
      </div>
    );
  }
  return (
    <div className="cs-page ide-page">
      <IdePanel internal={internal} onOpenSession={internal ? () => navigate('/dev') : null} />
    </div>
  );
}
